<!--
  - 页脚
-->

<template>
  <div class="footer">
    <ul>
      <!--			<li>-->
      <!--				<router-link :to="{name: 'ContactUs'}">联系我们</router-link>-->
      <!--			</li>-->
      <li>
        <router-link :to="{name: 'Feedback'}">反馈建议</router-link>
      </li>
      <li>
        <router-link :to="{name: 'AboutUs'}">网站说明</router-link>
      </li>
    </ul>
    <div class="copyright">
      Copyright <a href="https://www.bytelang.com"
                   style="margin: 0 5px; text-decoration: underline">www.bytelang.com</a>
      © 2016-2021.<a href="http://beian.miit.gov.cn/" target=_blank> 陕ICP备16017267号 </a> All Rights Reserved.
      Current Version
      <span style="margin-left: 5px;" v-text="version+'-'+hash"></span>
      <span style="margin-left: 5px;" v-text="'on '+date"></span>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'banner',
  data(){
    return {
      version: "v2.0.4",
      hash: "1jkjkd",
      date: "",
    };
  },
  methods: {},
  created(){
    this.version = process.env.VUE_APP_VERSION;
    this.hash = process.env.VUE_APP_HASH;
    this.date = process.env.VUE_APP_DATE;
  }
}
</script>

<style scoped lang="less">
@import "../../src/theme/default";

.footer {
  height: @footer_height;
  padding: 30px 0;
  display: flex;
  background: #363636;
  color: white;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ul {
    display: flex;
    flex-direction: row;

    li {
      display: flex;
      padding: 10px 20px;
      font-size: 14px;
    }
  }

  .copyright {
    display: flex;
  }

  /deep/ a {
    color: white;
  }

  /deep/ a:hover {
    box-sizing: border-box;
    text-decoration: underline;
  }
}
</style>
